import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "font-weight-bold mr-1"
};
export default {
  __name: 'LlAutocomplete',
  props: {
    modelValue: {
      type: [Object, String, Number],
      required: false,
      default: null
    },
    search: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    itemTitle: {
      type: [String, Function],
      default: 'label'
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    density: {
      type: String,
      default: 'compact'
    },
    variant: {
      type: String,
      default: 'outlined'
    },
    componentClass: {
      type: String,
      default: 'remove-outline'
    },
    placeholder: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: [Boolean, String],
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: String,
      default: 'text-sm'
    },
    invalid: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: ''
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    }
  },
  emits: ['update:modelValue', 'update:search'],
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tw", __props.horizontal ? 'flex-col' : 'flex-row'])
      }, [_createElementVNode("label", {
        class: _normalizeClass(__props.labelClass)
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), _withDirectives(_createElementVNode("span", _hoisted_1, "*", 512), [[_vShow, __props.isRequired]])], 2), _createVNode(_component_v_autocomplete, {
        "data-cy": __props.dataCy,
        modelValue: __props.modelValue,
        search: __props.search,
        items: __props.items,
        "item-title": __props.itemTitle,
        "item-value": __props.itemValue,
        density: __props.density,
        variant: __props.variant,
        class: _normalizeClass(__props.componentClass + (__props.invalid ? ' error' : '')),
        placeholder: __props.placeholder,
        "hide-details": __props.hideDetails,
        clearable: __props.clearable,
        disabled: __props.disabled,
        loading: __props.loading,
        "error-messages": __props.errorMessages,
        "no-filter": "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event)),
        "onUpdate:search": _cache[1] || (_cache[1] = $event => _ctx.$emit('update:search', $event))
      }, _createSlots({
        _: 2
      }, [_ctx.$slots.item ? {
        name: "item",
        fn: _withCtx(slotProps => [_renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(slotProps)))]),
        key: "0"
      } : undefined, _ctx.$slots['append-item'] ? {
        name: "append-item",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "append-item")]),
        key: "1"
      } : undefined, _ctx.$slots['prepend-item'] ? {
        name: "prepend-item",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "prepend-item")]),
        key: "2"
      } : undefined, _ctx.$slots['no-data'] ? {
        name: "no-data",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "no-data")]),
        key: "3"
      } : undefined, _ctx.$slots.selection ? {
        name: "selection",
        fn: _withCtx(slotProps => [_renderSlot(_ctx.$slots, "selection", _normalizeProps(_guardReactiveProps(slotProps)))]),
        key: "4"
      } : undefined]), 1032, ["data-cy", "modelValue", "search", "items", "item-title", "item-value", "density", "variant", "class", "placeholder", "hide-details", "clearable", "disabled", "loading", "error-messages"])], 2);
    };
  }
};